<template>
  <div class="stationGroupForm tableStyle">
    <el-row>
      <el-col :span="24">
        <query
          :formData="formData"
          :formList="formList"
          @reset="resetQuery"
          @query="query"
          @clear="query"
        ></query>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-button size="small" @click="download">导出会员数据</el-button>
      </el-col>
    </el-row>

    <div class="tableArea">
      <el-table :data="tableData" class="table-border" height="100%">
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column prop="name" label="用户名" align="center"></el-table-column>
        <el-table-column prop="mobile" label="联系电话" align="center"></el-table-column>
        <el-table-column prop="created_at" label="注册时间" align="center"></el-table-column>
        <el-table-column label="当前套餐" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.current_combo.status == 0">
              -
            </span>
            <span v-else>
              {{scope.row.current_combo.info.name}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="recharge_statistical.recharge_times" label="充电次数" align="center"></el-table-column>
        <el-table-column prop="recharge_statistical.recharge_sum" label="充电电量" align="center">
          <template slot-scope="scope">
            {{scope.row.recharge_statistical.recharge_sum}}kwh
          </template>
        </el-table-column>

        <el-table-column prop="user_type" label="用户类型" align="center"></el-table-column>
        <el-table-column label="厂商/物业名称" align="center">
            <template slot-scope="scope">
              {{scope.row.company && scope.row.company.name }}
            </template>
        </el-table-column>

        <el-table-column label="套餐有效期" align="center" width="320">
          <template slot-scope="scope">
            <span v-if="scope.row.current_combo.status == 0">-</span>
            <span v-else>
              {{scope.row.current_combo.info.start_time}} 至 {{scope.row.current_combo.info.end_time}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
              <el-button plain size="mini" @click="handleBindCompany(scope.row)">绑定厂商/物业</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="updated_at" label="最后使用时间" align="center"></el-table-column> -->
      </el-table>
    </div>

    <div class="pageFoot flex">
      <div class="statistical">
        统计：会员总数（{{total}}）&nbsp;近一周新增（{{pageData.week_add}}）&nbsp;近一月新增（{{pageData.month_add}}）&nbsp;包日（{{pageData.combo_day}}）&nbsp;包月（{{pageData.combo_month}}）&nbsp;包年（{{pageData.combo_year}}）
      </div>
      <el-pagination
        layout="total, prev, pager, next, sizes"
        background
        :page-size="size"
        :total="total"
        :page-sizes="[20,50,100,200,500,1000]"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>
    </div>


    <!-- 弹窗 -->
    <el-dialog title="绑定厂商/物业" width="30%" custom-class="dialogRadius" :close-on-click-modal="false" :close-on-press-escape="false"  :visible.sync="dialogVisible"
      @close="handleCloseBindCompany('addForm')">
      <el-form :model="addForm" :rules="rules" ref="addForm" label-width="auto" size="small">
        <el-form-item label="类型：" prop="company_type">
            <el-select v-model="addForm.company_type" style="width: 100%" placeholder="请选择类型" @change="handleSelectCompany(addForm.company_type)">
              <el-option label="厂商" :value="1"></el-option>
              <el-option label="物业" :value="2"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="所属厂商/物业：" prop="cid">
          <el-select v-model="addForm.cid" filterable style="width: 100%" @click.native="!addForm.company_type?$message.error('请先选择类型'):''" :disabled="!addForm.company_type">
            <el-option v-for="(item, index) in allCompany"
                :label="item.name"
                :value="item.id"
                :key="index">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleBindCompanySubmit('addForm')">确 定</el-button>
      </span>      
    </el-dialog>


  </div>
</template>
<script>
import Query from "components/query.vue";
export default {
  data() {
    return {
        size: 20,
        page: 1,
        total: 0,
        allManufacturer: [],
        formData: {
          name: '',
          mobile: '',
          start_date: '',
          end_date: '',
        },
        formList: [
            {
              type: 'input',
              label: '用户名：',
              placeholder: '请输入用户名',
              model: 'name'
            },
            {
              type: 'input',
              label: '联系电话：',
              placeholder: '请输入联系电话',
              model: 'mobile'
            },
            {
              type: 'datePicker',
              label: '注册时间',
              placeholder1: '开始时间',
              placeholder2: '结束时间',
              model1: 'start_date',
              model2: 'end_date',
            }
        ],

        tableData: [],
        pageData: {
          combo_day: 0,
          combo_month: 0,
          combo_year: 0,
          month_add: 0,
          total: 0,
          week_add: 0,
        },

        dialogVisible:false,
        addForm:{
          uid:'',
          cid: '',
        },
        rules: {
          company_type:[{required: true, message: "请选择类型", trigger: 'change'}],
          cid: [
              { required: true, message: "请选择所属厂商/物业", trigger: 'change'}
          ],
        },
        allCompany:[],



    };
  },
  components: {
    Query,
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init(){
      this.getTableList();
    },
    // 获取table列表
    getTableList(data){
        let params = {};
        if(data){
            params = data;
        }
        params.page = this.page;
        params.size = this.size;
        this.$http.get(this.common.admin + '/admin/userList',{
            params: params
        }).then(res => {
            if(res.code === 200){
                this.tableData = res.data.list;
                this.total = res.data.total;
                this.pageData = res.data.statistical;
            }else{
                this.$message.error(res.msg);
            }
        });
    },
    // 查询
    query(data) {
      this.page = 1;
      this.getTableList(data);
    },
    // 重置查询--运营端
    resetQuery() {
      this.page = 1;
        this.formData = {
            name: '',
            mobile: '',
        };
        this.getTableList();
    },
    // 翻页
    changePage(page){
      this.page = page;
      this.getTableList(this.formData);
    },
    sizeChange(val){
      this.size = val;
      this.getTableList(this.formData);
    },
    // 导出报表数据
    download(){
      this.$http.get(this.common.admin + '/admin/userList', {
        params: {
          page: 1,
          size: 10,
          name: '',
          mobile: '',
          export: 1
        },
        responseType: 'blob'
      }).then(res => {
        if(res.code === 400){
          return this.$message.error(res.msg);
        }else{
          let blob = new Blob([res], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"}); // 为blob设置文件类型，这里以.xlsx为例
          let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
          let a = document.createElement("a");
          a.href = url;
          a.click();
          // 释放这个临时的对象url
          window.URL.revokeObjectURL(url); 
        }
      });
    },


    //选择物业厂商
    handleSelectCompany(type){
      this.addForm.cid = '';
      this.allCompany = [];
      this.getAllCompany(type);
    },

    // 获取所有厂商列表
    getAllCompany(type){
      let params = {
        type: type  //类型 1厂商 2物业
      }
      this.$http.get(this.common.admin+'/admin/companyAllList',{params}).then(res => {
        if(res.code === 200){
            this.allCompany = res.data;          
          // this.allManufacturer = [{id: 0, name: '车安堡自营'}, ...res.data];
        }else{
          this.$message.error(res.msg);
        }
      });
    },


    //绑定厂商/物业
    handleBindCompany(row){
      if(row.company){
        this.addForm.cid = row.company.id;
        this.addForm.company_type = row.company.type;
        this.getAllCompany(row.company.type);
      }
      this.dialogVisible = true;      
      this.addForm.uid = row.id;
    },

    //关闭弹窗
    handleCloseBindCompany(formName){
      this.addForm = {
          uid:'',
          cid: '',
      }
      this.$refs[formName].resetFields();
    },

    //提交
    handleBindCompanySubmit(formName){
      
      this.$refs[formName].validate(valid=>{
        if(valid){
          this.$api.bindCompany(this.addForm).then(res=>{
            if(res.code === 200){
              this.$message.success('绑定成功');
              this.dialogVisible = false;
              this.getTableList();
            }else{
              this.$message.error(res.msg);
            }
          })
        }
      })
    },


  },
};
</script>
<style lang="less" scoped>
.stationGroupForm{
  height: 100%;
  display: flex;
  flex-direction: column;
  .tableArea{
    flex: 1;
    min-height: calc(100% - 184px);
  }
  .pageFoot{
    align-items: center;
    justify-content: space-between;
    .statistical{
      font-size: 14px;
    }
  }
}
</style>